module.exports = __webpack_public_path__ + "img/els-badge-background.9dcf1210.png";